import React from "react"



const Copyright = () => <p>
    © {new Date().getFullYear()} TreatMePal
</p>

export default Copyright